import {
  ShoppingCartItem,
  ShoppingCartQuery
} from '@dtx-company/flow-codegen/src/code/generated.types'

export const addPrintStoreUpdateQueryData = (
  currentState: ShoppingCartQuery,
  item: ShoppingCartItem
): void => {
  const currentCartItems = currentState.shoppingCart?.items || []
  Object.assign(currentState, {
    shoppingCart: {
      ...currentState.shoppingCart,
      items: [...currentCartItems, item]
    }
  })
}

export const editPrintStoreUpdateQueryData = (
  currentState: ShoppingCartQuery,
  itemId: string,
  newQuantity: number
): void => {
  const updatedItems =
    currentState.shoppingCart?.items?.map(cart =>
      cart?.itemId === itemId ? { ...cart, quantity: newQuantity } : cart
    ) || []
  Object.assign(currentState, {
    shoppingCart: {
      ...currentState.shoppingCart,
      items: updatedItems
    }
  })
}

export const deletePrintStoreUpdateQueryData = (
  currentState: ShoppingCartQuery,
  itemId: string
): void => {
  const updatedItems =
    currentState.shoppingCart?.items?.filter(item => item?.itemId !== itemId) || []
  Object.assign(currentState, {
    shoppingCart: {
      ...currentState.shoppingCart,
      items: updatedItems
    }
  })
}

export const confirmAndDeletePrintStoreUpdateQueryData = (
  currentState: ShoppingCartQuery
): void => {
  Object.assign(currentState, {
    shoppingCart: undefined
  })
}
